// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1FjUV","rootCenter":"LoadMoreObserver_rootCenter__1anxE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__nRV-P"};